module.exports = __webpack_public_path__ + "static/media/selfie-bg.c0eedfd7.png";